import { render, staticRenderFns } from "./BCMOE.vue?vue&type=template&id=4e200d32"
import script from "./BCMOE.vue?vue&type=script&lang=js"
export * from "./BCMOE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports